import React, { FC, useContext } from 'react';
import styles from './Tag.module.css';
import clsx from 'clsx';
import { SIZE, STYLE, VARIANT } from '@blackcart/base';
import { BlackcartContext } from '../../context';
import { InfoIcon, SVGWrapper } from '../svg';

export interface ITagColors {
  backgroundColor?: string;
  fontColor?: string;
  borderColor?: string;
}

const defaultColors: ITagColors = {
  backgroundColor: '#333',
  fontColor: '#fafafa',
  borderColor: '#333'
};

interface IBcTagProps extends Omit<React.HTMLAttributes<HTMLButtonElement>, 'size' | 'children'> {
  title?: string;
  withIcon?: boolean;
  size?: 'small' | 'regular';
  frameStyle?: 'solid' | 'outlined';
  borderRadius?: 'round' | 'regular' | 'square';
  colors?: ITagColors;
}

const Tag: FC<IBcTagProps> = ({
  title = 'Try before you buy',
  className,
  size = 'regular',
  frameStyle = 'solid',
  borderRadius = 'regular',
  onClick,
  style,
  colors = defaultColors,
  withIcon = false,
  ...restProps
}) => {
  const { showBlackcartModal, useModal } = useContext(BlackcartContext);

  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (useModal && showBlackcartModal) {
      showBlackcartModal(event.currentTarget);
    }
    onClick(event);
  };

  return (
    <button
      onClick={(event) => handleOnClick(event)}
      style={{
        ...(style || {}),
        ['--bcTag-backgroundColor']: colors.backgroundColor,
        ['--bcTag-fontColor']: colors.fontColor,
        ['--bcTag-borderColor']: colors.borderColor
      }}
      className={clsx(
        styles.root,
        {
          [styles.rootSmall]: size === SIZE.SMALL,
          [styles.rootOutlined]: frameStyle === STYLE.OUTLINED,
          [styles.rootSolid]: frameStyle === STYLE.SOLID,
          [styles.rootRound]: borderRadius === VARIANT.ROUND,
          [styles.rootSquare]: borderRadius === VARIANT.SQUARE,
          [styles.rootRegular]: borderRadius === VARIANT.REGULAR
        },
        'bc-tag__root',
        className
      )}
      {...restProps}
    >
      <span
        className={clsx(
          styles.text,
          {
            [styles.textSmall]: size === SIZE.SMALL
          },
          'bc-tag__text'
        )}
      >
        {title}
      </span>
      {withIcon && (
        <span
          className={clsx(
            styles.icon,
            {
              [styles.iconSmall]: size === SIZE.SMALL
            },
            'bc-tag__icon--root'
          )}
        >
          <SVGWrapper size={size === SIZE.SMALL ? '14px' : '16px'} label="info-icon">
            <InfoIcon />
          </SVGWrapper>
        </span>
      )}
    </button>
  );
};

export { Tag };
